export const OAuthConfig = {
    httpData:
    {
        baseURL: localStorage.getItem('baseURL'),
        response_type: "code",
        state: "state",
        code_challenge: localStorage.getItem("SSO-codeChallenge") || "",
        code_challenge_method: "S256"
    }
}